'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _components2 = require('components');

var _SHARE = require('components/SHARE');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BasketProductDetail: {
        displayName: 'BasketProductDetail'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/default/BasketProductDetail.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var BasketProductDetail = _wrapComponent('BasketProductDetail')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(BasketProductDetail, _Component);

    function BasketProductDetail(props) {
        (0, _classCallCheck3.default)(this, BasketProductDetail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BasketProductDetail.__proto__ || (0, _getPrototypeOf2.default)(BasketProductDetail)).call(this, props));

        _this.renderNested = function (itemChild, lang, itemError) {
            var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

            if (itemChild.quantity == 0) {
                return null;
            }
            var modifier_option_name = _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-2' },
                _react3.default.createElement('div', { className: 'title' })
            );
            var sum = itemChild.price * itemChild.count;
            if (itemChild.childOffer.modifierName !== null && itemChild.childOffer.modifierName !== undefined) {
                modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        itemChild.childOffer.modifierName
                    )
                );
            }
            var childWeight = itemChild.quantity;
            if ((itemChild.childOffer.unit.slug === 'kg' || itemChild.childOffer.unit.slug === 'mg') && itemChild.weight && itemChild.weight > 0 && itemChild.quantity > 0) {
                childWeight = itemChild.weight * itemChild.quantity;
                childWeight = childWeight.toFixed(3);
                if (itemChild.weight < 0.01 && childItem.quantity < 1 || itemChild.weight < 1 && itemChild.quantity < 0.01) {
                    childWeight = itemChild.weight * 1;
                }
                if (itemChild.weight < 0.1 && itemChild.quantity < 0.1) {
                    childWeight = itemChild.weight * 1;
                }
            }
            var paddingLeft = level * 30 + 'px';
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin', style: { clear: 'both' } },
                _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 visible-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        itemChild.childOffer.name,
                        ' ',
                        itemChild.childOffer.modifierName
                    ),
                    _react3.default.createElement(
                        'div',
                        { style: { paddingLeft: '49px' } },
                        _react3.default.createElement(
                            'span',
                            null,
                            _this.props.lang['store.common.quantity'],
                            ': ',
                            childWeight,
                            ' ',
                            _this.props.lang[itemChild.childOffer.unit.title_lang_data]
                        )
                    )
                ),
                itemError && itemError.child_offer_id !== null && itemError.child_offer_id.indexOf(itemChild.childOffer.id) !== -1 ? _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 hidden-xs', style: { color: '#e9594a' } },
                    _react3.default.createElement(
                        'div',
                        { style: { paddingLeft: paddingLeft }, className: 'title' },
                        '- ',
                        itemChild.childOffer.name
                    )
                ) : _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { style: { paddingLeft: paddingLeft }, className: 'title' },
                        '- ',
                        itemChild.childOffer.name
                    )
                ),
                modifier_option_name,
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'quantity_counter_child' },
                        childWeight,
                        ' ',
                        lang[itemChild.childOffer.unit.title_lang_data]
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement('div', { className: 'price' })
                ),
                itemChild.childOffer.type_id === 5 && itemChild.childOffer.nestedOffers ? itemChild.childOffer.nestedOffers.map(function (item, keyArray) {
                    return _this.renderNested(item, lang, itemError, level + 1);
                }) : null
            );
        };

        return _this;
    }

    (0, _createClass3.default)(BasketProductDetail, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                id = _props.id,
                name = _props.name,
                description = _props.description,
                count = _props.count,
                sum = _props.sum,
                picture = _props.picture,
                itemError = _props.itemError,
                modifier_option_id = _props.modifier_option_id,
                remainder_quantity = _props.remainder_quantity,
                lang = _props.lang,
                currency = _props.currency,
                keyArray = _props.keyArray,
                basket_number = _props.basket_number,
                custom_fields = _props.custom_fields;


            var outOfStock = lang['store.cart_detail.out_of_stock'];
            var available = lang['store.cart_detail.available'];

            if (picture && (picture.preview_url || picture.url)) {
                picture = picture.preview_url ? picture.preview_url : picture.url;

                picture = _react3.default.createElement(
                    _reactRouter.Link,
                    { to: '/product/' + id, className: 'thumb-holder' },
                    _react3.default.createElement('img', { className: 'lazy', style: { width: '73px' }, alt: name, src: picture })
                );
            } else {
                picture = '';
            }
            var modifier_option_name = _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-2 prod_desc' },
                _react3.default.createElement('div', { className: 'title' })
            );
            if (modifier_option_id !== null && modifier_option_id !== undefined) {
                modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        this.props.modifier_option.name
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'title visible-xs' },
                        this.props.modifier_option.name
                    )
                );
            } else if (this.props.modifier_option_name !== null && this.props.modifier_option_name !== undefined) {
                modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        this.props.modifier_option_name
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'title visible-xs' },
                        this.props.modifier_option_name
                    )
                );
            }
            var childWeight = null;
            var weight = null;
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin cart-item' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-1' },
                    picture,
                    _react3.default.createElement('a', { className: 'close-btn pointer visible-xs', onClick: function onClick(e) {
                            _this2.props.onDelete(id, modifier_option_id, keyArray);
                        } }),
                    _react3.default.createElement(
                        'div',
                        { className: 'quantity_counter visible-xs' },
                        itemError ? _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(_components2.QuantityProduct, { value: count, callback: function callback(newCount) {
                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
                                } }),
                            _react3.default.createElement(
                                'div',
                                { className: 'basket_item_error' },
                                _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
                                itemError.count_offer - 0 <= 0 ? outOfStock : available + ' ' + itemError.count_offer
                            )
                        ) : _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(_components2.QuantityProduct, { value: count,
                                checkValue: remainder_quantity !== null && remainder_quantity !== undefined,
                                checkCount: remainder_quantity,
                                callback: function callback(newCount) {
                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
                                } })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'price' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: sum,
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value
                            })
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4' },
                    basket_number !== undefined ? _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        _react3.default.createElement(
                            'h4',
                            null,
                            lang['store.postpone.basketNumber'] + (basket_number + 1)
                        )
                    ) : null,
                    _react3.default.createElement(
                        'div',
                        { className: 'title prod_desc hidden-xs' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/product/' + id },
                            name
                        ),
                        _react3.default.createElement(_SHARE.SwitherDescription, { description: description }),
                        custom_fields ? custom_fields.map(function (item, i) {
                            return _react3.default.createElement(
                                'label',
                                null,
                                item.name,
                                ': ',
                                item.value
                            );
                        }) : null,
                        itemError && itemError.is_edited ? _react3.default.createElement(
                            'div',
                            { className: 'basket_item_error' },
                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
                            lang['store.cart_detail.error.editNested']
                        ) : null
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'title visible-xs' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/product/' + id },
                            name
                        ),
                        _react3.default.createElement(_SHARE.SwitherDescription, { description: description }),
                        custom_fields ? custom_fields.map(function (item, i) {
                            return _react3.default.createElement(
                                'label',
                                null,
                                item.name,
                                ': ',
                                item.value
                            );
                        }) : null,
                        itemError && itemError.is_edited ? _react3.default.createElement(
                            'div',
                            { className: 'basket_item_error' },
                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
                            lang['store.cart_detail.error.editNested']
                        ) : null
                    )
                ),
                modifier_option_name,
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
                    itemError ? _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'quantity_counter' },
                            _react3.default.createElement(_components2.QuantityProduct, { value: count, callback: function callback(newCount) {
                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
                                } })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'basket_item_error' },
                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
                            itemError.count_offer - 0 <= 0 ? outOfStock : available + ' ' + itemError.count_offer
                        )
                    ) : _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'quantity_counter' },
                            _react3.default.createElement(_components2.QuantityProduct, { value: count,
                                checkValue: remainder_quantity !== null && remainder_quantity !== undefined,
                                checkCount: remainder_quantity,
                                callback: function callback(newCount) {
                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
                                } })
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'price' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: sum,
                            icon: currency.icon,
                            iconAfterValue: currency.icon_after_value
                        })
                    ),
                    _react3.default.createElement('a', { className: 'close-btn pointer hidden-xs', onClick: function onClick(e) {
                            _this2.props.onDelete(id, modifier_option_id, keyArray);
                        } })
                ),
                this.props.type_id === 5 && this.props.nested_offer ? this.props.nested_offer.map(function (item, keyArray) {
                    var sum = item.price * item.count;
                    if (item.quantity == 0) {
                        return null;
                    }
                    modifier_option_name = _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2' },
                        _react3.default.createElement('div', { className: 'title' })
                    );
                    if (item.childOffer.modifierName !== null && item.childOffer.modifierName !== undefined) {
                        modifier_option_name = _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-2 hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                item.childOffer.modifierName
                            )
                        );
                    }
                    weight = item.quantity;
                    if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
                        weight = item.weight * item.quantity;
                        weight = weight.toFixed(3);
                        if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
                            weight = item.weight * 1;
                        }
                        if (item.weight < 0.1 && item.quantity < 0.1) {
                            weight = item.weight * 1;
                        }
                    }
                    return _react3.default.createElement(
                        'div',
                        { className: 'row no-margin', style: { clear: 'both' } },
                        _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-4 visible-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'title', style: { paddingLeft: '20px' } },
                                '\u2022 ',
                                item.childOffer.name,
                                ' ',
                                item.childOffer.modifierName
                            ),
                            _react3.default.createElement(
                                'div',
                                { style: { paddingLeft: '30px' } },
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    _this2.props.lang['store.common.quantity'],
                                    ': '
                                ),
                                item.childOffer.type_id === 5 ? _react3.default.createElement(
                                    'span',
                                    null,
                                    item.quantity
                                ) : _react3.default.createElement(
                                    'span',
                                    null,
                                    weight,
                                    ' ',
                                    _this2.props.lang[item.childOffer.unit.title_lang_data]
                                )
                            )
                        ),
                        itemError && itemError.child_offer_id !== null && itemError.child_offer_id.indexOf(item.childOffer.id) !== -1 ? _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-4 hidden-xs', style: { color: '#e9594a' } },
                            _react3.default.createElement(
                                'div',
                                { style: { paddingLeft: '20px' }, className: 'title' },
                                '\u2022\u200E ',
                                item.childOffer.name
                            )
                        ) : _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-4 hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { style: { paddingLeft: '20px' }, className: 'title' },
                                '\u2022\u200E ',
                                item.childOffer.name
                            )
                        ),
                        modifier_option_name,
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-3 hidden-xs' },
                            item.childOffer.type_id === 5 ? _react3.default.createElement(
                                'div',
                                { className: 'quantity_counter_child' },
                                item.quantity
                            ) : _react3.default.createElement(
                                'div',
                                { className: 'quantity_counter_child' },
                                weight,
                                ' ',
                                lang[item.childOffer.unit.title_lang_data]
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-2 hidden-xs' },
                            _react3.default.createElement('div', { className: 'price' })
                        ),
                        item.childOffer.type_id === 5 && item.childOffer.nestedOffers ? item.childOffer.nestedOffers.map(function (itemChild, keyArray) {
                            return _this2.renderNested(itemChild, lang, itemError);
                        }) : null
                    );
                }) : null
            );
        }
    }]);
    return BasketProductDetail;
}(_react2.Component), _class.defaultProps = {
    itemError: null
}, _class.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp));

exports.default = BasketProductDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/default/BasketProductDetail.jsx
// module id = 748
// module chunks = 0